import React, { useEffect, useState } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import { urlAdd } from 'Utils/URL'

export const ToggleButtonUnstyled = ({
  value: defaultValue,
  options,
  onChange,
  className,
  url,
  nullable = false,
}) => {
  const [value, setValue] = useState(defaultValue)

  const changeValue = (e, value) => {
    if (!nullable && !value) return
    url && urlAdd(url, value)
    setValue(value)
    onChange && onChange(value)
  }

  useEffect(() => {
    value !== defaultValue && setValue(defaultValue)
  }, [defaultValue])

  return (
    <ToggleButtonGroup
      className={className}
      value={value}
      exclusive
      onChange={changeValue}
    >
      {options.map(({ value, label }, key) => (
        <ToggleButton key={key} value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
